import script from "./CalendarWarning.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalendarWarning.vue?vue&type=script&lang=ts&setup=true"

import "./CalendarWarning.vue?vue&type=style&index=0&id=001ab51f&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-001ab51f"]])

export default __exports__